import Image1 from "../src/Images/fav.png"
import Image2 from "../src/Images/same.png"

const images = {
    logo: Image1,
    banner: Image2,
}

export default images;